import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import('../src/javascripts/slider_splide');
